import React, {
  useState,
} from 'react';
import {
  confirmable,
  createConfirmation,
} from 'react-confirm';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';

const TextareaDialog = ({
  show,
  proceed,
  dismiss,
  cancel,
  content,
  options,
}) => {
  const {
    t,
  } = useTranslation(undefined, { useSuspense: false });
  const [text, setText] = useState(options?.defaultValue ?? '');

  return (
    <Dialog
      open={show}
      onClose={dismiss}
      fullWidth
      className="textarea-dialog"
    >
      {options?.title && (
        <DialogTitle>
          {options.title}
        </DialogTitle>
      )}
      <DialogContent>
        <div style={{
          marginBottom: 20,
        }}>
          {content}
        </div>
        <TextField
          label={t('Text')}
          value={text}
          onChange={(event) => {
            setText(event.target.value);
          }}
          multiline
          rows={2}
          fullWidth
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => { cancel() }}
        >
          {t('Close')}
        </Button>
        <Button
          color="primary"
          autoFocus
          onClick={() => { proceed(text) }}
        >
          {t('Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const textarea = createConfirmation(confirmable(TextareaDialog));

export default function(content, options = {}) {
  return textarea({ content, options });
}
